import { useField } from 'formik'
import PropTypes from 'prop-types'

export const MySelect = ({ label, ...props }) => {
  const [field] = useField(props)
  return (
    <div>
      <label
        className="mb-2 block text-sm font-medium text-gray-900 dark:text-gray-300"
        htmlFor={props.id || props.name}
      >
        {label}
      </label>
      <select
        {...field}
        {...props}
        className={
          'block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900' +
          ' focus:border-gray-500 focus:ring-gray-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white' +
          ' dark:placeholder-gray-400 dark:focus:border-gray-500 dark:focus:ring-gray-500'
        }
      />
    </div>
  )
}
export default MySelect

MySelect.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string,
  name: PropTypes.string,
}
